import { bus } from '@/core/bus';
import { hasAsset, assetUrl } from '@/assets/assetManager';

/** 音效：優先播放 public/assets/audio/{name}.mp3，沒有檔案就用 WebAudio 合成提示音 */
let ctx: AudioContext | null = null;
let enabled = true;
const TONES: Record<string, [number, number, OscillatorType]> = {
  click: [660, 0.06, 'triangle'], ok: [880, 0.18, 'triangle'], warn: [330, 0.25, 'square'],
  alarm: [220, 0.5, 'sawtooth'], rewind: [520, 0.6, 'sine'], door: [440, 0.12, 'sine'], item: [990, 0.3, 'triangle'],
};
export function setSound(on: boolean) { enabled = on; }
function play(name: string) {
  if (!enabled) return;
  const file = `audio/${name}.mp3`;
  if (hasAsset(file)) { const a = new Audio(assetUrl(file)); a.volume = 0.5; a.play().catch(() => {}); return; }
  try {
    ctx = ctx || new (window.AudioContext || (window as any).webkitAudioContext)();
    if (ctx.state !== 'running') ctx.resume();
    const [f, d, type] = TONES[name] ?? TONES.click;
    const o = ctx.createOscillator(), g = ctx.createGain(), t0 = ctx.currentTime;
    o.type = type; o.frequency.value = f;
    if (name === 'rewind') o.frequency.exponentialRampToValueAtTime(f * 0.4, t0 + d);
    g.gain.setValueAtTime(0.0001, t0); g.gain.exponentialRampToValueAtTime(0.06, t0 + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t0 + d);
    o.connect(g); g.connect(ctx.destination); o.start(t0); o.stop(t0 + d + 0.03);
  } catch { /* 無音效環境 */ }
}
export function initSfx() { bus.on('sfx', play); }
